<div class="mainPagecontent">
    <app-sidepanel></app-sidepanel>
    <span class="content">

        <nz-spin style="position: absolute" *ngIf="loading" nzSimple [nzSize]="'large'"></nz-spin>

        <div>
            <div *ngIf="!loading && businessData">
                <h1 class="formTitle">We found an account with your organisation email</h1>
                <p class="subTitle" style="margin-bottom: 20px;">
                    A Terragon Prime account already exists with your organisation’s email. Do you want to join the account?
                </p>

                <div class="existing">
                    <div class="companyInfo">
                        <div class="companyLogo">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 0C8.95428 0 0 8.95431 0 20C0 31.0457 8.95428 40 20 40C29.9101 40 38.1366 32.7924 39.7235 23.3333H39.58C38.0999 29.0841 32.8795 33.3333 26.6667 33.3333C19.3029 33.3333 13.3334 27.3638 13.3334 20C13.3334 12.6362 19.3029 6.66667 26.6667 6.66667C32.8795 6.66667 38.0999 10.9159 39.58 16.6667H39.7235C38.1366 7.20762 29.9101 0 20 0Z" fill="#52AABD"/>
                                <path d="M0 20C0 8.95431 8.95432 0 20 0C29.91 0 38.1366 7.20762 39.7235 16.6667H26.2467C24.7665 10.9159 19.5462 6.66667 13.3334 6.66667C5.96955 6.66667 0 12.6362 0 20Z" fill="#095A87"/>
                                <path d="M0 20C0 31.0457 8.95432 40 20 40C29.91 40 38.1366 32.7924 39.7235 23.3333H26.2467C24.7665 29.0841 19.5462 33.3333 13.3334 33.3333C5.96955 33.3333 0 27.3638 0 20Z" fill="#095A87"/>
                            </svg> 
                        </div>
                        <div>
                            <h2>{{businessData[0]?.business_name || businessData[0]?.contact_name}}</h2>
                            <p>{{businessData[0]?.contact_email}}</p>
                        </div>                           
                    </div>
                    <div class="existingList">
                        <div *ngFor="let b of businessData.slice(0, 2)" class="existingUser">
                            {{getInitials(b.business_name || b.contact_name)}}
                        </div>
                        <div *ngIf="businessData?.length > 2" class="existingUser extra">
                            +{{ businessData?.length - 2 }}
                        </div>
                    </div>
                </div>

                <button nz-button nzType="primary" class="w-100 padd-top" (Click)="requestToJoin()">Request to Join Account</button>
                <p style="margin-top: 15px;">
                    Need another business? <a href="" (click)="triggerGAButton()">Create new</a>
                </p>
            </div>
        </div>

    </span>
    <div class="chatPosition triggerGA" dataEventAction="chatbot_click" dataEventCategory="auth-existing-account_page" dataEventLabel="existing-account-chatbot_click">
        <a href="" onclick="javascript:$zoho.salesiq.floatwindow.visible('show')" href="javascript:void(0)">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="28" cy="28" r="28" fill="#008138"/>
                <path d="M33.8277 27.5518C33.8277 28.1067 33.6073 28.6388 33.215 29.0311C32.8227 29.4234 32.2906 29.6438 31.7358 29.6438H19.1839L15 33.8277V17.092C15 16.5371 15.2204 16.005 15.6127 15.6127C16.005 15.2204 16.5371 15 17.092 15H31.7358C32.2906 15 32.8227 15.2204 33.215 15.6127C33.6073 16.005 33.8277 16.5371 33.8277 17.092V27.5518Z" fill="white"/>
                <path d="M22.1724 33.8284C22.1724 34.3832 22.3928 34.9153 22.7851 35.3077C23.1774 35.7 23.7095 35.9204 24.2643 35.9204H36.8162L41.0001 40.1043V23.3686C41.0001 22.8137 40.7797 22.2816 40.3874 21.8893C39.9951 21.497 39.463 21.2766 38.9081 21.2766H24.2643C23.7095 21.2766 23.1774 21.497 22.7851 21.8893C22.3928 22.2816 22.1724 22.8137 22.1724 23.3686V33.8284Z" fill="white" stroke="#008138" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </a>
    </div>
</div>